import type { TenantInvite, TenantInviteBase } from "../../../types/admin";
import { createAdminBaseService } from "./adminBaseService";

const base = createAdminBaseService<TenantInvite, TenantInviteBase>({
  tableName: "tenant_invites",
  searchColumns: ["email", "token"],
});

export class AdminInviteService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
